// Ajuste de la selección de poses cuando cambia la cantidad de modelos
// activos (single ↔ varios modelos) o llega el catálogo. Lógica PURA del
// efecto de compatibilidad de InterfazV2, extraída para poder testearla:
// la versión inline solo consultaba el catálogo global (`allPosesFiltered`)
// y descartaba SIEMPRE las poses propias ("Mis poses"), aunque su
// `cantidad_personas` coincidiera con los modelos activos.
// Ver ADR-2026-08-24-estado-multi-modelo-consistente.

export interface AjustarPosesInput {
  /** Selección actual (`poseIds`). */
  prev: string[];
  /** Ids de las poses GLOBALES compatibles con la cantidad de modelos
   *  (`allPosesFiltered` — ya viene ordenado recomendadas-primero, así que
   *  su primer ítem es el default de reemplazo). */
  compatiblesGlobales: string[];
  /** Ids de las poses PROPIAS compatibles (customPoses con
   *  `cantidadPersonas === expectedPeopleInPose`). */
  compatiblesCustom: string[];
  /** Cantidad de modelos activos (1 en single; 1 + extras en multi). */
  expectedPeopleInPose: number;
}

/** Devuelve la selección ajustada. Si no hay cambios devuelve `prev` (misma
 *  referencia) para que el setState no dispare re-render. */
export function ajustarPosesPorCantidadDeModelos(i: AjustarPosesInput): string[] {
  const permitidas = new Set([...i.compatiblesGlobales, ...i.compatiblesCustom]);
  let next = i.prev.filter((id) => permitidas.has(id));
  // En multi-modelo capamos a 1 pose: con N personas el flujo no soporta
  // multi-pose (multiplicación de imágenes por pose).
  if (i.expectedPeopleInPose > 1 && next.length > 1) {
    next = [next[0]];
  }
  if (next.length === i.prev.length && next.every((id, idx) => id === i.prev[idx])) {
    return i.prev;
  }
  // Si el descarte dejó la selección vacía, autoseleccionamos la primera
  // global compatible — espejo del default recomendado (las custom nunca son
  // default automático).
  if (next.length === 0 && i.compatiblesGlobales.length > 0) {
    return [i.compatiblesGlobales[0]];
  }
  return next;
}
